import { Injectable } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { catchError, concatMap, map, take, tap } from 'rxjs/operators';
import { HeaderFooterMachCore } from '../../models/header-footer-mach-core/header-footer-mach-core.interfaces';
import { LangSelectorExtendedFacade } from './langselector-extended.facade';

@Injectable({
  providedIn: 'root'
})
export class LangSelectorFacade extends LangSelectorExtendedFacade {
  init(): void {
    const prefValue = this.countryLanguageHelper?.prefCookie;
    if (!prefValue) {
      this.countryLanguageHelper?.setPreferredLanguages(
        this.appConfig.getConfig('HEADER')?.['APP_PREF_COOKIE'] || 'en-us'
      );
    }

    this.contentService
      .getHeaderFooterMachCoreContent$()
      .pipe(
        take(1),
        concatMap((data: HeaderFooterMachCore) => {
          if (!data) {
            return EMPTY;
          }

          this.countryLanguageContent = data.footer.countrylanguage;
          this.contentFooter = data.footer;

          return this.countryLangSvc.getCountryLanguageData();
        }),
        concatMap((countryLanguageData) => {
          if (!countryLanguageData) {
            return EMPTY;
          }

          return this.countryLanguageHelper.getPreferredLanguages().pipe(
            map((prefCountry) => ({
              countryLanguageData,
              prefCountry
            }))
          );
        }),
        tap(({ countryLanguageData, prefCountry }) => {
          if (prefCountry) {
            this.countryLanguageHelper.setData(countryLanguageData);
            this.countryLanguageList =
              this.countryLanguageHelper.getCountryLanguageList();
            this.prefCookieValue = prefCountry;

            if (this.prefCookieValue && this.prefCookieValue.length > 0) {
              const res = this.prefCookieValue.split('-');
              // For Hamburger Language Selector
              this.langCode = res[0].toUpperCase();
              this.countrySlector = res[1].toLowerCase();

              // For Language Selector in footer
              this.setCountryNameWithPrimaryLang(res);
            }

            this.languageSelectorContent$ = of({
              feedback: this.contentFooter.feedback as Record<string, never>,
              social: this.contentFooter.socialIcons,
              prefLanguage: this.prefLanguage,
              secondaryPrefLanguage: this.secondaryPrefLanguage
            });
          }
        }),
        catchError((error) => {
          this.loggingService.log(`Caught Error: ${error}`);
          return EMPTY;
        })
      )
      .subscribe();
  }

  changeLanguage(): void {
    const langselector = this.secondaryPrefLanguage?.languageCode;
    const prefValue = langselector + '-' + this.countrySlector;

    this.cookieHelper.setCookies('prefUI', prefValue);

    this.countryLanguageHelper.redirectToTranslatedSitesForContentPages(
      this.countrySlector,
      langselector
    );
  }

  open(): void {
    const disableCLS =
      this.appConfig.getConfig('HEADER')?.['APP_DISABLE_CLS2'] === 'true';
    if (!disableCLS) {
      this.selectorFacade.showSelectorModal.set(true);
      this.selectorFacade.init();
    }
  }
}
